<template>
  <div class="view-contains">
    <Head :class="{ 'scrolled': isScrolled }" />
    <div class="screen-content">
      <ViewMain />
    </div>
  </div>
</template>

<script>
import ViewMain from './components/ViewMain'
import Head from './components/Head.vue'
export default {
  components: {
    ViewMain,
    Head
  },
  data() {
    return {
      isScrolled: false

    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 头部滚动改变背景色
    handleScroll() {
      this.isScrolled = window.scrollY > 0
    }
  }

}
</script>
<style lang="scss" scoped>
.scrolled{
  background: rgba(255,255,255,0.1);
  box-shadow: 0px 4px 12px 0px rgba(20,97,191,0.04);
  backdrop-filter: blur(40px);
  ::v-deep {
    .el-menu {
      background: transparent;
    }
  }
}
</style>
